import React from 'react'
import { HStack, Image, Text, Button } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import StoreCoinSvg from '@images/store_coin.svg'

export const CoinPlanRow = ({ coin, iosPrice, webPrice, onSelect }) => (
  <HStack w="100%" p="12px 16px" justify="space-between" align="center">
    {/* 左側: コイン数 */}
    <HStack gap={1} flex="0 0 auto">
      <Image w="20px" h="20px" src={buildAssetUrlString(StoreCoinSvg)} />
      <Text fontSize="md" fontWeight="600" lineHeight="22px">
        {coin.toLocaleString()}
      </Text>
    </HStack>

    {/* 右側: 割引表示とボタン */}
    <HStack gap={2} flex="0 0 auto">
      {/* iOS価格（ある場合） */}
      {iosPrice && (
        <HStack gap={1}>
          <Text fontSize="sm" textDecoration="line-through" textDecorationColor="externalPayment.discount" lineHeight="18px">
            ¥{iosPrice.toLocaleString()}
          </Text>
          <Text fontSize="sm" color="externalPayment.discount">
            →
          </Text>
        </HStack>
      )}

      {/* 購入ボタン */}
      <Button
        w="100px"
        h="36px"
        bgColor="secondary.main"
        color="label.primary"
        fontSize="sm"
        fontWeight="600"
        lineHeight="22px"
        borderRadius="4px"
        onClick={onSelect}
        _hover={{ opacity: 0.8 }}
      >
        ¥{webPrice.toLocaleString()}
      </Button>
    </HStack>
  </HStack>
)
